/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./frame-btn.vue?vue&type=template&id=52e62272&scoped=true&"
import script from "./frame-btn.vue?vue&type=script&lang=ts&"
export * from "./frame-btn.vue?vue&type=script&lang=ts&"
import style0 from "./frame-btn.vue?vue&type=style&index=0&id=52e62272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e62272",
  null
  
)

export default component.exports